<template>
  <v-card class="card-border">
    <v-card-text>
      <v-btn
        outlined
        color="blue darken-2"
        rounded
        dark
        depressed
        small
        @click="$refs.dialogConsorcio.show(false, {})"
      >
        <v-icon left>mdi-plus-circle</v-icon>Novo Consorcio
      </v-btn>
      <DialogConsorcio ref="dialogConsorcio" @created="createConsorcio($event)" />
      <v-form ref="form">
        <v-row dense align="center">
          <v-col cols="2">
            <SelectAtivo @onChanged="itemsSelectAtivo = $event" />
          </v-col>
          <v-col cols="5">
            <v-btn outlined color="blue darken-2" rounded dark depressed small @click="buscar()">
              <v-icon left>mdi-magnify</v-icon>Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Consorcio from "@/services/consorcio";

export default {
  name: "Filtro",

  components: {
    SelectEmpresa: () => import("@/components/select/SelectEmpresa"),
    DialogConsorcio: () => import("./DialogConsorcio"),
    SelectAtivo: () => import("@/components/select/SelectAtivo")
  },

  data() {
    return {
      empresas: [],
      serviceConsorcio: new Consorcio(),
      itemsSelectAtivo: ""
    };
  },

  methods: {
    ...mapActions("consorcio", ["setConsorcios"]),

    async buscar() {
      try {
        if (this.$refs.form.validate()) {
          const response = await this.serviceConsorcio.getByAtivo(
            this.itemsSelectAtivo == "Sim" ? true : false
          );
          this.setConsorcios(response);
        }
      } catch (error) {
        this.$toast.error(`Erro ao buscar os dados`);
      }
    },

    createConsorcio(consorcio) {
      if (this.getConsorcios === null) {
        this.setConsorcios([{ ...consorcio }]);
      } else {
        this.setConsorcios(this.getConsorcios.concat(...[{ ...consorcio }]));
      }
    }
  },

  computed: {
    ...mapGetters("consorcio", ["getConsorcios"])
  },

  async mounted() {
    try {
      if (this.getConsorcios.length === 0) {
        const response = await this.serviceConsorcio.getByAtivo(true);
        this.setConsorcios(response);
      }
    } catch (error) {
      this.$toast.error(`Erro ao buscar os dados`);
    }
  }
};
</script>
